module.exports = __webpack_public_path__ + "media/images/faces/male/11-57f8bd67a8c8c01807303d1de95de23b.jpg";